import type { PaywallStatus } from "@/react/types";
import { usePunditUserContext } from "@circle-react/contexts";
import { PaywallFormContent } from "./PaywallFormContent";
import { usePaywallFormContentCreateFlow } from "./hooks/usePaywallFormContentCreateFlow";
import { usePaywallFormContentEditFlow } from "./hooks/usePaywallFormContentEditFlow";

interface PaywallFormContentOrchestratorProps {
  activeTab: string;
  canChangeCurrency: boolean;
  currentPaywallStatus?: PaywallStatus;
  hasSubscribers: boolean;
  isSubmitting: boolean;
  // todo: convert PaywallsAdmin/hooks/usePaywallApi.js to TypeScript
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- we will fix this later when we convert
  mutation: any;
  requiresCurrency: boolean;
  setActiveTab: (tab: string) => void;
}

export const PaywallFormContentOrchestrator = ({
  activeTab,
  setActiveTab,
  mutation,
  isSubmitting,
  currentPaywallStatus,
  requiresCurrency,
  canChangeCurrency,
  hasSubscribers,
}: PaywallFormContentOrchestratorProps) => {
  const { currentCommunitySettings } = usePunditUserContext();

  const hook = !currentPaywallStatus
    ? usePaywallFormContentCreateFlow
    : usePaywallFormContentEditFlow;

  return (
    <PaywallFormContent
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      usePaywallFormContentHook={hook}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- we will fix this later when we convert the files to typescript
      mutation={mutation}
      isSubmitting={isSubmitting}
      currentPaywallStatus={currentPaywallStatus}
      requiresCurrency={requiresCurrency}
      canChangeCurrency={canChangeCurrency}
      workflowsEnabled={
        currentCommunitySettings?.upgrade_flows_for_workflows_paywalls_enabled ??
        false
      }
      hasSubscribers={hasSubscribers}
    />
  );
};
